import {
  GET_DRIVERS_SETTLEMENT,
  GET_SEARCH_DRIVERS_SETTLEMENT
} from "../actions/reportsSettlement";

export default function(state = {}, action) {
  switch (action.type) {
    case GET_DRIVERS_SETTLEMENT:
      return { ...state, ...action.payload };
    case GET_SEARCH_DRIVERS_SETTLEMENT:
      return { ...state, ...action.payload.data };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/reportsSettlement.js